import ModelInterface from 'src/models/ModelInterface'
import {RawRecipient} from '@/types/entity/RawRecipient'
import store from '@/store/index'

class Recipient extends ModelInterface<RawRecipient> {

  constructor (data: RawRecipient) {
    super(data)
  }

  public getId () {
    return this.data.lsn_id
  }

  public getFirstName () {
    return this.data.first_name || '';
  }

  public getLastName () {
    return this.data.last_name || '';
  }

  public getMiddleName () {
    return this.data.middle_name || '';
  }

  public getMailingId () {
    return this.data.mailing_id;
  }

  public getFilter () {
    return this.data.filter;
  }

  public getMsgrs () {
    return this.data.msgr || false;
  }

  public getSendStatus () {
    const status = this.data.send_status
    if (!status) return false
    const dc = (status as any).dc
    if (dc && dc.err && dc.ok === undefined) {
      return { ...status, dc: { ts: dc.ts, ok: dc.err.ok } }
    }
    return status
  }

  public getStatus () {
    return this.data.status || false
  }

  public getUpic () {
    return this.data.upic || false
  }


  /**
   * Recipient full name
   * @returns {String}
   */
  public getFullName () {
    let fullName = ''
    fullName += this.data.last_name ? this.data.last_name + ' ' : ''
    fullName += this.data.first_name ? this.data.first_name + ' ' : ''
    fullName += this.data.middle_name ? this.data.middle_name + ' ' : ''
    return fullName;
  }

  get first_name () {
    return this.getFirstName();
  }

  get last_name () {
    return this.getLastName();
  }

  get middle_name () {
    return this.getMiddleName();
  }

  get messengers () {
    return this.getMsgrs();
  }
}

export default Recipient